import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import OfoqTextField from '../../../components/Forms/OfoqTextField'
import OfoqThemeBtn from '../../../components/Buttons/OfoqThemeBtn'
import { sendForgetPasswordEmail } from '../../../redux/features/userAuth/userAuthThunk'
import UseTranslation from '../../../hooks/UseTranslation'

const EmailForm = ({ setSendEmail }) => {
  const [email, setEmail] = useState('')
  const dispatch = useDispatch()
  const { t } = UseTranslation()

  const submitHandler = () => {
    if (email) {
      dispatch(
        sendForgetPasswordEmail({
          queries: {
            email,
          },
        }),
      ).then((res) => {
        if (res?.meta?.requestStatus === 'fulfilled') {
          setSendEmail(true)
        }
      })
    }
  }

  return (
    <Box>
      <Typography component={'p'} sx={styles.formSubTitle}>
        {t?.['Enter the Email Address you are using while login, and the instructions to reset your password will be sent to your Mail.']}
      </Typography>
      <OfoqTextField
        customStyle={styles.textField}
        defaultValue={email}
        refState={setEmail}
        type='email'
        required
        name={t?.['Email Address']}
        customPlaceHolder={t?.['Type Your Email Address']}
      />
      <Box sx={styles.formBtns}>
        <OfoqThemeBtn
          customStyle={styles.continueBtn(email)}
          name={t?.Continue}
          type='submit'
          onClick={submitHandler}
          disabled={!email}
        />
      </Box>
    </Box>
  )
}

const styles = {
  formSubTitle: {
    width: { sm: '520px' },
    fontSize: { xs: '12px', sm: '14px' },
    mb: { xs: '15px', sm: '25px' },
    fontWeight: 300,
  },
  textField: {
    marginBottom: '10px',
    fontSize: { xs: '14px', sm: '16px !important' },
    '& .snapIcon': {
      display: 'none',
    },
  },
  continueBtn: (email) => ({
    maxWidth: { xs: '100%', sm: '180px' },
    height: '40px',
    color: 'white !important',
    background: email ? 'primary.main' : 'rgba(41, 204, 139, 0.5)',
  }),
  formBtns: {
    display: 'flex',
    minWidth: '100%',
    justifyContent: { xs: 'center', sm: 'flex-end' },
    marginTop: { xs: '10px', sm: '30px' },
  },
}

export default EmailForm
